// Generated by design-architect. Do not edit manually.
// Theme: OMS (oms)

export const designTheme = {
  id: "oms",
  name: "OMS",
  description: "Light financial product theme for OMS dashboards.",
} as const;

export const designTokens = {
  colors: {
    page: "#F6F6FC",
    surface: "#FFFFFF",
    secondarySurface: "#F6F6FC",
    header: "#FFFFFF",
    headerBorder: "#DFE3F0",
    footer: "#FFFFFF",
    primaryText: "#141635",
    secondaryText: "#64708F",
    placeholderText: "#929EBA",
    border: "#C8CFE1",
    focusRing: "#B78EEF",
    brand: "#670DE5",
    hover: "#F6F6FC",
    primaryButton: "#090624",
    primaryButtonText: "#FFFFFF",
    secondaryButton: "#FFFFFF",
    secondaryButtonText: "#090624",
    selectedButton: "#EAE4F5",
    selectedButtonText: "#500AB2",
    danger: "#DC2626",
    dangerSoft: "#FEF2F2",
    dangerText: "#FFFFFF",
    success: "#047857",
    successSoft: "#ECFDF5",
    warning: "#B45309",
    warningSoft: "#FFF7ED",
    info: "#500AB2",
    infoSoft: "#F6F3FB",
  },
  rawColors: {
    "background": {
      "canvas": "#F6F6FC",
      "page": "#FFFFFF",
      "search": "#F6F6FC",
      "searchActive": "#EEF0F9",
      "searchSelected": "#D5C4F2",
      "surface": "#FFFFFF",
      "surfaceHover": "#F6F6FC",
      "surfaceInverse": "#141635",
      "surfaceSelected": "#EAE4F5"
    },
    "border": {
      "default": "#C8CFE1",
      "divider": "rgba(0,0,0,0.05)",
      "focus": "#B78EEF",
      "hover": "#929EBA",
      "strongHover": "#090624",
      "subtle": "#DFE3F0"
    },
    "brand": {
      "border": "#D5C4F2",
      "default": "#670DE5",
      "hover": "#500AB2",
      "ring": "#B78EEF",
      "surface": "#F6F3FB"
    },
    "button": {
      "disabledBg": "#C8CFE1",
      "disabledText": "#929EBA",
      "primaryActiveBg": "#400A8E",
      "primaryBg": "#090624",
      "primaryHoverBg": "#222744",
      "primaryText": "#FFFFFF",
      "secondaryActiveBg": "#EAE4F5",
      "secondaryActiveBorder": "#D5C4F2",
      "secondaryBg": "#FFFFFF",
      "secondaryBorder": "#64708F",
      "secondaryHoverBorder": "#090624",
      "secondaryText": "#090624"
    },
    "foreground": {
      "disabled": "#C8CFE1",
      "inverse": "#FFFFFF",
      "link": "#670DE5",
      "linkHover": "#500AB2",
      "primary": "#141635",
      "secondary": "#64708F",
      "tertiary": "#929EBA"
    },
    "semantic": {
      "danger": {
        "bg": "#FEF2F2",
        "border": "#FECACA",
        "buttonActiveBg": "#991B1B",
        "buttonBg": "#DC2626",
        "buttonHoverBg": "#EF4444",
        "fg": "#B91C1C"
      },
      "info": {
        "bg": "#F6F3FB",
        "border": "#D5C4F2",
        "fg": "#500AB2"
      },
      "success": {
        "bg": "#ECFDF5",
        "border": "#A7F3D0",
        "fg": "#047857"
      },
      "warning": {
        "bg": "#FFF7ED",
        "border": "#FED7AA",
        "fg": "#B45309"
      }
    }
  },
  typography: {
    fontFamily: "Fustat",
    headingWeight: 700,
    bodyWeight: 500,
    lineHeight: 1.2,
    raw: {
      "documentation": {
        "family": "Inter"
      },
      "mono": {
        "family": "Geist"
      },
      "product": {
        "bodyWeight": 500,
        "boldWeight": 700,
        "family": "Fustat",
        "lineHeight": 1.2
      },
      "scale": {
        "body1": {
          "size": 20,
          "weight": 500
        },
        "body2": {
          "size": 18,
          "weight": 500
        },
        "body3": {
          "size": 16,
          "weight": 500
        },
        "body4": {
          "size": 14,
          "weight": 500
        },
        "body5": {
          "size": 12,
          "weight": 500
        },
        "h1": {
          "size": 48,
          "weight": 700
        },
        "h2": {
          "size": 40,
          "weight": 700
        },
        "h3": {
          "size": 32,
          "weight": 700
        },
        "h4": {
          "size": 28,
          "weight": 700
        },
        "h5": {
          "size": 24,
          "weight": 700
        }
      }
    },
  },
  spacing: {
    "base": 4,
    "scale": [
      4,
      8,
      12,
      16,
      20,
      24,
      32,
      40,
      48,
      64,
      80,
      96,
      128
    ]
  },
  radii: {
    button: 12,
    buttonLarge: 12,
    input: 12,
    badge: 999,
    card: 24,
    raw: {
      "2xl": 24,
      "badge": 999,
      "button": 12,
      "card": 24,
      "input": 12,
      "lg": 12,
      "md": 8,
      "menu": 16,
      "modal": 24,
      "pill": 999,
      "popover": 24,
      "sm": 6,
      "xl": 16,
      "xs": 4
    },
  },
  borders: {
    defaultWidth: "1px",
    boxWidth: "1px",
    labelWidth: "1px",
    buttonWidth: "1px",
    focusRingWidth: "2px",
    raw: {
      "componentBorders": {
        "buttonSecondary": "1px solid button.secondaryBorder",
        "card": "1px solid border.subtle",
        "input": "1px solid border.default",
        "tableRow": "1px solid border.subtle"
      },
      "defaultWidth": 1,
      "focusRingWidth": 2
    },
  },
  shadows: {
    "button": "0 1px 2px 0 rgba(0,0,0,0.05)",
    "card": "none",
    "drawer": "0 4px 6px -4px rgba(0,0,0,0.10), 0 10px 15px -3px rgba(0,0,0,0.10)",
    "modal": "0 4px 6px -4px rgba(0,0,0,0.10), 0 10px 15px -3px rgba(0,0,0,0.10)",
    "popover": "0 4px 6px -4px rgba(0,0,0,0.10), 0 10px 15px -3px rgba(0,0,0,0.10)"
  },
  motion: {
    hover: "120ms ease-out",
    base: "200ms ease-out",
    modal: "320ms ease-out",
    raw: {
      "allowed": [
        "fade",
        "slide"
      ],
      "base": "200ms ease-out",
      "disallowed": [
        "bounce",
        "spring",
        "parallax",
        "scale-shrink"
      ],
      "hover": "120ms ease-out",
      "modal": "320ms ease-out"
    },
  },
  components: {
    "appShell": {
      "activeNavBg": "brand.surface",
      "activeNavText": "brand.hover",
      "mainBg": "background.canvas",
      "sidebarBg": "background.surface",
      "sidebarWidth": 240,
      "topNavHeight": 64
    },
    "badge": {
      "fontSize": 12,
      "fontWeight": 500,
      "paddingX": 10,
      "paddingY": 3,
      "radius": 999,
      "tableDotRequired": true
    },
    "button": {
      "sizes": {
        "lg": {
          "fontSize": 16,
          "height": 40,
          "paddingX": 12
        },
        "md": {
          "fontSize": 14,
          "height": 32,
          "paddingX": 12
        },
        "sm": {
          "fontSize": 12,
          "height": 30,
          "paddingX": 8
        }
      },
      "states": [
        "default",
        "hover",
        "active",
        "focusVisible",
        "disabled"
      ],
      "variants": [
        "primary",
        "secondary",
        "dangerPrimary",
        "dangerSecondary"
      ]
    },
    "card": {
      "border": "border.subtle",
      "padding": [
        16,
        20,
        24
      ],
      "radius": 24,
      "shadow": "none",
      "surface": "background.surface"
    },
    "drawer": {
      "anchor": "right",
      "height": "full",
      "motion": "slide"
    },
    "input": {
      "activeHeight": 44,
      "height": 40,
      "helperTextRequired": true,
      "labelRequired": true,
      "paddingX": 12,
      "radius": 12,
      "states": [
        "default",
        "active",
        "filled",
        "focusFilled",
        "disabled",
        "destructive"
      ]
    },
    "modal": {
      "desktopWidth": 400,
      "mobilePresentation": "bottom-sheet",
      "radius": 24
    },
    "table": {
      "cellPaddingX": 18,
      "cellPaddingY": 12,
      "headerBg": "background.canvas",
      "headerFont": "documentation",
      "headerSize": 11,
      "monoColumns": [
        "addresses",
        "timestamps",
        "ids"
      ],
      "rowHoverBg": "background.canvas"
    },
    "toast": {
      "paddingX": 20,
      "paddingY": 16,
      "placement": "bottom-right",
      "radius": 24,
      "shadow": "popover"
    }
  },
} as const;

export type DesignButtonVariant = "primary" | "secondary" | "selected" | "dangerPrimary" | "dangerSecondary";
export type DesignBadgeVariant = "info" | "neutral" | "success" | "warning" | "danger";
export type StyleRecipe = Record<string, string | number>;

export const buttonRecipe: Record<DesignButtonVariant, StyleRecipe> = {
  primary: {
    background: designTokens.colors.primaryButton,
    color: designTokens.colors.primaryButtonText,
    border: `${designTokens.borders.buttonWidth} solid ${designTokens.colors.border}`,
    borderRadius: designTokens.radii.button,
    minHeight: 40,
    paddingInline: 12,
    fontSize: 16,
    hoverBackground: "#222744",
    activeBackground: "#400A8E",
    disabledBackground: "#C8CFE1",
    disabledColor: "#929EBA",
    transition: designTokens.motion.hover,
  },
  secondary: {
    background: designTokens.colors.secondaryButton,
    color: designTokens.colors.secondaryButtonText,
    border: `${designTokens.borders.buttonWidth} solid #64708F`,
    borderRadius: designTokens.radii.button,
    minHeight: 40,
    paddingInline: 12,
    fontSize: 16,
    hoverBorderColor: "#090624",
    activeBackground: "#EAE4F5",
    activeBorderColor: "#D5C4F2",
    disabledBackground: "#C8CFE1",
    disabledColor: "#929EBA",
    transition: designTokens.motion.hover,
  },
  selected: {
    background: designTokens.colors.selectedButton,
    color: designTokens.colors.selectedButtonText,
    border: `${designTokens.borders.buttonWidth} solid ${designTokens.colors.border}`,
    borderRadius: designTokens.radii.button,
    minHeight: 40,
    paddingInline: 12,
    fontSize: 16,
  },
  dangerPrimary: {
    background: designTokens.colors.danger,
    color: "#FFFFFF",
    border: `${designTokens.borders.buttonWidth} solid ${designTokens.colors.border}`,
    borderRadius: designTokens.radii.button,
    minHeight: 40,
    paddingInline: 12,
    fontSize: 16,
    hoverBackground: "#EF4444",
    activeBackground: "#991B1B",
    transition: designTokens.motion.hover,
  },
  dangerSecondary: {
    background: designTokens.colors.dangerSoft,
    color: designTokens.colors.dangerText,
    border: `${designTokens.borders.buttonWidth} solid ${designTokens.colors.border}`,
    borderRadius: designTokens.radii.button,
    minHeight: 40,
    paddingInline: 12,
    fontSize: 16,
    hoverBackground: designTokens.colors.hover,
    transition: designTokens.motion.hover,
  },
};

export const inputRecipe = {
  default: {
    background: designTokens.colors.secondarySurface,
    color: designTokens.colors.primaryText,
    placeholderColor: designTokens.colors.placeholderText,
    border: "1px solid #C8CFE1",
    borderRadius: designTokens.radii.input,
    minHeight: 40,
    paddingInline: 12,
    transition: designTokens.motion.hover,
  },
  active: {
    borderColor: designTokens.colors.focusRing,
    boxShadow: `0 0 0 ${designTokens.borders.focusRingWidth} ${designTokens.colors.focusRing}`,
    minHeight: 44,
  },
  disabled: {
    background: "#C8CFE1",
    color: "#929EBA",
  },
  destructive: {
    borderColor: designTokens.colors.danger,
    color: designTokens.colors.primaryText,
  },
} as const;

export const badgeRecipe: Record<DesignBadgeVariant, StyleRecipe> = {
  info: { background: designTokens.colors.infoSoft, color: designTokens.colors.info, border: `${designTokens.borders.labelWidth} solid ${designTokens.colors.border}`, borderRadius: designTokens.radii.badge, paddingBlock: 3, paddingInline: 10, fontSize: 12, fontWeight: 500 },
  neutral: { background: designTokens.colors.secondarySurface, color: designTokens.colors.primaryText, border: `${designTokens.borders.labelWidth} solid ${designTokens.colors.border}`, borderRadius: designTokens.radii.badge, paddingBlock: 3, paddingInline: 10, fontSize: 12, fontWeight: 500 },
  success: { background: designTokens.colors.successSoft, color: designTokens.colors.success, border: `${designTokens.borders.labelWidth} solid ${designTokens.colors.border}`, borderRadius: designTokens.radii.badge, paddingBlock: 3, paddingInline: 10, fontSize: 12, fontWeight: 500 },
  warning: { background: designTokens.colors.warningSoft, color: designTokens.colors.warning, border: `${designTokens.borders.labelWidth} solid ${designTokens.colors.border}`, borderRadius: designTokens.radii.badge, paddingBlock: 3, paddingInline: 10, fontSize: 12, fontWeight: 500 },
  danger: { background: designTokens.colors.dangerSoft, color: designTokens.colors.dangerText, border: `${designTokens.borders.labelWidth} solid ${designTokens.colors.border}`, borderRadius: designTokens.radii.badge, paddingBlock: 3, paddingInline: 10, fontSize: 12, fontWeight: 500 },
};

export const cardRecipe = {
  default: {
    background: "#FFFFFF",
    border: "1px solid #DFE3F0",
    borderRadius: designTokens.radii.card,
    boxShadow: "none",
    padding: 16,
  },
  resource: {
    background: "#FFFFFF",
    border: `${designTokens.borders.boxWidth} solid ${designTokens.colors.headerBorder}`,
    borderRadius: designTokens.radii.card,
    padding: 16,
  },
} as const;

export const tableRecipe = {
  header: {
    background: "#F6F6FC",
    color: designTokens.colors.secondaryText,
    fontSize: 11,
  },
  row: {
    borderBottom: "1px solid #DFE3F0",
    hoverBackground: "#F6F6FC",
  },
  cell: {
    paddingBlock: 12,
    paddingInline: 18,
  },
} as const;

export const overlayRecipe = {
  modal: {
    background: designTokens.colors.surface,
    border: `${designTokens.borders.boxWidth} solid ${designTokens.colors.border}`,
    borderRadius: 24,
    boxShadow: designTokens.shadows.modal ?? "none",
    maxWidth: 400,
  },
  drawer: {
    background: designTokens.colors.surface,
    boxShadow: designTokens.shadows.drawer ?? "none",
    anchor: "right",
  },
  toast: {
    background: designTokens.colors.surface,
    border: `${designTokens.borders.boxWidth} solid ${designTokens.colors.border}`,
    borderRadius: 24,
    boxShadow: designTokens.shadows.popover ?? "none",
    paddingBlock: 16,
    paddingInline: 20,
  },
} as const;

export const appShellRecipe = {
  sidebarWidth: 240,
  topNavHeight: 64,
  sidebarBackground: "#FFFFFF",
  mainBackground: "#F6F6FC",
  activeNavBackground: "#F6F3FB",
  activeNavText: "#500AB2",
} as const;

export const componentRecipe = {
  page: {
    background: designTokens.colors.page,
    color: designTokens.colors.primaryText,
    fontFamily: designTokens.typography.fontFamily,
  },
  card: {
    ...cardRecipe.default,
  },
  input: {
    ...inputRecipe.default,
  },
  header: {
    background: designTokens.colors.header,
    color: designTokens.colors.primaryText,
    borderBottom: `1px solid ${designTokens.colors.headerBorder}`,
  },
  footer: {
    background: designTokens.colors.footer,
    color: designTokens.colors.secondaryText,
  },
  badge: {
    ...badgeRecipe,
  },
} as const;
